export const PieChartHead = "Total number of cleaner visits"
export const PieChartPara = "The graph shows the total number of visits broken down by visitor type"
export const AttendedClean = "Attended Clean"
export const DownloadCSV = "Download CSV"
export const MissedClean = "Missed Clean"
export const Store = "Store"
export const Visitor = "Visitor"
export const PurposeVisit = "Purpose of visit"
export const Compliance = "Compliance"
export const Date = "Date"
export const TimeIn = "Time in"
export const TimeOut = "Time out"
export const ShowingPage = "Showing Page"
export const Of = "Of" 
export const DashBoardVisitorId = 0 
export const Placeholder = "Search by name or company "
export const PlaceholderMissedCleans = "Search by hubid or hubname "
export const chartLabelColleagues = "Colleagues"
export const chartLabelContractors = "Contractors"
export const chartLabelCleaners = "Cleaners"
export const chartLabelRepresentatives = "Merchandising"
export const chartLabelSecurity = "Security Guards"
export const chartLabelEnforcement = "Enforcement"
export const chartLabelOther = "Other Colleagues"
export const chartLabelCleaningManager = "Cleaning Manager"
export const chartLabelCleaningAuditor = "Cleaning Auditor"
export const chartLabelParkingOfficer = "Parking Officer"
export const chartLabelMemberOfParliamnet = "Member Of Parliament"
export const ColleaguesColor = 'rgb(255, 99, 132)'
export const ContractorsColor = 'rgb(255, 159, 64)'
export const CleanersColor = '#05acd1'
export const RepresentativesColor = 'rgb(75, 192, 192)'
export const SecurityColor = 'rgb(54, 162, 235)'
export const EnforcementColor = 'rgb(153, 102, 255)'
export const OtherColor = 'rgb(153, 95, 120)'
export const CleaningManagerColor = '#333333'
export const CleaningAuditorColor = '#008784'
export const ParkingOfficerColor = 'rgb(255, 140, 100)'
export const MemberOfParliamentColor = 'rgb(153, 140, 111)'
export const January = "January"
export const February = "February"
export const March = "March"
export const April = "April"
export const May = "May"
export const June = "June"
export const July = "July"
export const August = "August"
export const September = "September"
export const October = "October"
export const November = "November"
export const December = "December"
export const FirePolicy = "Fire Policy"
export const Asbestos = "Asbestos"
export const NoDataAvailable = "No Data Available."
export const BracketCleaningServices = " (Cleaning Services)"
export const BracketCleaningManager = " (Cleaning Manager)"
export const BracketCleaningAuditor = " (Cleaning Auditor)"
export const MissedCleanerVisits = "Missed cleaner visits"
export const MissedCleanerVisitsP = "How many cleaner visits failed in 30 days?"
export const Jan = "Jan"
export const Feb = "Feb"
export const Mar = "Mar"
export const Apr = "Apr"
export const Jun = "Jun"
export const Jul = "Jul"
export const Aug = "Aug"
export const Sep = "Sep"
export const Oct = "Oct"
export const Nov = "Nov"
export const Dec = "Dec"
export const HubId = "Hub Id"
export const HubName = "Hub Name"
export const SupplierName = "Supplier Name"